module.exports = __webpack_public_path__ + "img/image10.affb0a5c.jpg";